import { MutationOptions, useMutation } from 'react-query';

import { convertEmptyStringToNull } from '@app/features/addressBook/libs';
import {
  createBulkContacts,
  CreateBulkContactsParams,
  CreateBulkContactsResponse,
} from '@app/store/transport-layer/document/address-book/bulk/contacts';

export default function useCreateBulkContacts(
  options?: MutationOptions<CreateBulkContactsResponse, Error, CreateBulkContactsParams>
) {
  return useMutation<CreateBulkContactsResponse, Error, CreateBulkContactsParams>(
    (contacts) =>
      createBulkContacts(
        contacts.map(
          ({
            bizNumber,
            companyName,
            defaultForwardingMethod,
            departmentPosition,
            description,
            email,
            name,
            phoneNumber,
          }) => ({
            bizNumber: convertEmptyStringToNull(bizNumber),
            companyName: convertEmptyStringToNull(companyName),
            defaultForwardingMethod,
            departmentPosition: convertEmptyStringToNull(departmentPosition),
            description: convertEmptyStringToNull(description),
            email: convertEmptyStringToNull(email),
            name,
            phoneNumber: convertEmptyStringToNull(phoneNumber),
          })
        )
      ),
    options
  );
}
